import VueRouter from "vue-router";
import Vue from "vue";

/**
 * Components
 */
import NotFound from '@/components/errors/NotFound.vue';

import Home from '@/components/pages/HomePage.vue';

import ServiceSetting from '@/components/pages/settings/ServiceSettingPage.vue';
import XCookiesSetting from '@/components/pages/settings/XCookiesSetting.vue';
import SettingPage from '@/components/pages/settings/SettingPage.vue';

import AccountDataPage from "@/components/pages/data/AccountDataPage.vue";
import XAccount from '@/components/pages/data/XAccount.vue';
import FbAccount from '@/components/pages/data/FbAccount.vue';
import HotmailAccount from '@/components/pages/data/HotmailAccount.vue';

import LoginPage from '@/components/auth/LoginPage.vue';

import ProcedurePage from '@/components/pages/procedure/ProcedurePage.vue';
import ListProcedure from '@/components/pages/procedure/ListProcedure.vue';
import CreateProcedure from '@/components/pages/procedure/CreateProcedure.vue';
import EditProcedure from '@/components/pages/procedure/EditProcedure.vue';

import JobPage from '@/components/pages/job/JobPage.vue';
import ListJob from '@/components/pages/job/ListJob.vue';
import CreateJob from '@/components/pages/job/CreateJob.vue';
import EditJob from '@/components/pages/job/EditJob.vue';
import ListThread from '@/components/pages/job/ListThread.vue';

/**
 * Routes
 */

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/settings',
    component: SettingPage,
    name: 'Setting',
    children: [
      {
        path: 'service',
        name: 'ServiceSetting',
        component: ServiceSetting
      },
      {
        path: 'x-cookies',
        name: 'XCookiesSetting',
        component: XCookiesSetting
      },
    ]
  },
  {
    path: '/data',
    component: AccountDataPage,
    name: 'Data',
    children: [
      {
        path: 'x-accounts',
        name: 'XAccount',
        component: XAccount
      },
      {
        path: 'fb-accounts',
        name: 'FbAccount',
        component: FbAccount
      },
      {
        path: 'hotmail-accounts',
        name: 'HotmailAccount',
        component: HotmailAccount
      },
    ]
  },
  {
    path: '/auth/login',
    name: 'LoginPage',
    component: LoginPage
  },
  {
    path: '/procedures',
    component: ProcedurePage,
    name: 'Procedure',
    children: [
      {
        path: 'create',
        name: 'CreateProcedure',
        component: CreateProcedure
      },
      {
        path: '/',
        name: 'ListProcedure',
        component: ListProcedure
      },
      {
        path: 'edit/:id',
        name: 'EditProcedure',
        component: EditProcedure,
        props: route => ({ id: route.params.id })
      }
    ]
  },
  {
    path: '/jobs',
    component: JobPage,
    name: 'Job',
    children: [
      {
        path: 'create',
        name: 'CreateJob',
        component: CreateJob
      },
      {
        path: '/',
        name: 'ListJob',
        component: ListJob
      },
      {
        path: 'edit/:id',
        name: 'EditJob',
        component: EditJob,
        props: route => ({ id: route.params.id })
      },
      {
        path: ':id/threads',
        name: 'ListThread',
        component: ListThread,
        props: route => ({ id: route.params.id })
      }
    ]
  },
  {
    path: '*',
    name: 'NotFound',
    component: NotFound
  }
];

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  routes
});

export default router;